import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MaskType } from "src/app/constants/masks";
/**
 * component will translate by default set [autoTranslate]="false" to prevent translation
 * 
 */
@Component({
    selector: 'mwp-input',
    templateUrl: './input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public labelName: string;
    @Input() public inputType: string = "text";
    @Input() public maskType: MaskType;
    @Input() public hideLabel: boolean;
    @Input() public maxLength: number;
    @Input() public autoTranslate: boolean = true;
    @Input() public enableKeyUpEvent: boolean;
    @Input() public enableOnPasteEvent: boolean;
    @Input() public autoComplete: string;

    @Output() public emitKeyUp: EventEmitter<any> = new EventEmitter();
    @Output() public emitPaste: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    onKeyUp(event: KeyboardEvent) {
        if (this.enableKeyUpEvent)
            this.emitKeyUp.emit(event);
    }

    onPaste(event: ClipboardEvent) {
        if (this.enableOnPasteEvent)
            this.emitPaste.emit(event);
    }
}